import React, { useState } from 'react';
import PopupHocSinhTheoTrangThaiBox from './PopupHocSinhTheoTrangThaiBox';

// Định nghĩa kiểu dữ liệu
interface HocSinhKqhtChiTietResponse {
	ten_truong: string;
	ten_truong_en: string;
	dm_khoi_id: number;
	ten_khoi: string;
	ten_khoi_en: string;
	ten_he: string;
	ten_he_en: string;
	dm_he_id: number;
	ten_lop: string;
	ten_lop_en: string;
	rowspanKhoi: number;
	rowspanHe: number;
	so_luongs: number[];
}

// Định nghĩa props
interface DataTableProps {
	dataReport: {
		dm_xep_hangs: string[];
		dm_hoc_sinh_xep_hangs: HocSinhKqhtChiTietResponse[];
	};
}

const DataTableTheoTrangThai: React.FC<DataTableProps> = ({ dataReport }) => {
	const [expandedGrades, setExpandedGrades] = useState<{ [key: number]: boolean }>({});
	const [isShowPopup, setShowPopup] = useState(false);
	const [idHe, setIdHe] = useState(0);
	const [idKhoi, setIdKhoi] = useState(0);
	const [trangThai, setTrangThai] = useState(-1);
	const toggleGrade = (gradeId: number) => {
		setExpandedGrades((prevState) => ({
			...prevState,
			[gradeId]: !prevState[gradeId],
		}));
	};

	const onClose = () => {
		setShowPopup(false);
	}

	const onOpenPopup = (idHeTmp: number, trangThaiTmp: number, idKhoiTmp: number) => {
		setTrangThai(trangThaiTmp)
		setIdHe(idHeTmp)
		setIdKhoi(idKhoiTmp)
		setShowPopup(true)
	}

	function calculateTotal(data: any[], dmKhoiId: number, thuTu: number): number {
		return data
			.filter(item => item.dm_khoi_id === dmKhoiId) // Lọc theo điều kiện dm_khoi_id = 6
			.reduce((total, item) => total + (item.so_luongs[thuTu] || 0), 0); // Tính tổng phần tử đầu tiên trong mảng so_luongs
	}

	return (
		<>
			<table>
				<thead>
					<tr>
						<th>Khối</th>
						<th>Hệ</th>
						{dataReport?.dm_xep_hangs &&
							dataReport.dm_xep_hangs.map((item, index) => (
								<th key={index} className="text-center">{item}</th>
							))}
					</tr>
				</thead>
				<tbody>
					{dataReport?.dm_hoc_sinh_xep_hangs &&
						dataReport.dm_hoc_sinh_xep_hangs.reduce<JSX.Element[]>((acc, item, index) => {
							const isExpanded = expandedGrades[item.dm_khoi_id];
							const isTotal = item.ten_khoi === 'Tổng cộng';

							// Nếu là hàng đầu tiên hoặc "Tổng cộng", thêm hàng chính
							if (
								index === 0 ||
								dataReport.dm_hoc_sinh_xep_hangs[index - 1].dm_khoi_id !== item.dm_khoi_id ||
								isTotal
							) {
								acc.push(
									<tr
										key={`header-${item.dm_khoi_id}`}
										className="expandable-row"
										style={{ backgroundColor: isTotal ? '#f5f5f5' : '' }}
									>
										<td
											colSpan={2}
											style={{ cursor: isTotal ? 'default' : 'pointer', fontWeight: isTotal ? 'bold' : 'normal' }}
											onClick={!isTotal ? () => toggleGrade(item.dm_khoi_id) : undefined}
										>
											{!isTotal && <a href='#' className={!isTotal ? 'toggle-grade' : ''}>{item.ten_khoi}</a>}
											{isTotal && item.ten_khoi}
										</td>
										{!isTotal &&
											item.so_luongs.map((itemXh, i) => (
												<td
													key={`total-${i}`}
													className="text-center"
													style={{fontWeight: '500'}}
												>
													{calculateTotal(dataReport.dm_hoc_sinh_xep_hangs, item.dm_khoi_id, i)}
												</td>
											))}
										{isTotal &&
											item.so_luongs.map((itemXh, i) => (
												<td
													key={`summary-${i}`}
													className="text-center"
													style={{ fontWeight: 'bold' }}
												>
													{itemXh > 0 ? itemXh : '-'}
												</td>
											))}
									</tr>
								);
							}

							// Nếu đang mở rộng, thêm hàng chi tiết
							if (isExpanded && !isTotal) {
								acc.push(
									<tr key={`details-${index}`}>
										<td hidden={item.rowspanKhoi === 0} rowSpan={item.rowspanKhoi}>{item.ten_khoi}</td>
										<td>{item.ten_he}</td>
										{item.so_luongs.map((itemXh, i) => (
											<td
												key={`detail-${i}`}
												className="text-center"
											>
												{itemXh > 0 ? (
													<a href="#" onClick={() => onOpenPopup(item.dm_he_id, (i === 0 ? 22 : i === 1 ? 4 : 5), item.dm_khoi_id)}>
														{itemXh}
													</a>
												) : (
													'-'
												)}
											</td>
										))}
									</tr>
								);
							}
							return acc;
						}, [])}
				</tbody>
			</table>
			{isShowPopup && <PopupHocSinhTheoTrangThaiBox trang_thai={trangThai} dm_he_id={idHe} dm_khoi_id={idKhoi} onClose={onClose} />}
		</>
	);
};

export default DataTableTheoTrangThai;
